export default __webpack_public_path__ + "static/media/logo-text.42e545b0.png";